import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { inquiryGuides } from '@/mocks/contactData';

const guideHrefs = inquiryGuides.map((g) => g.href);
const guideIcons = inquiryGuides.map((g) => g.icon);

export default function InquiryGuideCards() {
  const { t } = useTranslation();

  const guides = guideIcons.map((icon, idx) => ({
    icon,
    href: guideHrefs[idx],
    titleEn: t(`contact.guides.${idx}.titleEn`),
    title: t(`contact.guides.${idx}.title`),
    description: t(`contact.guides.${idx}.description`),
    linkLabel: t(`contact.guides.${idx}.linkLabel`),
  }));

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('contact.guides.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('contact.guides.title')}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {t('contact.guides.subtitleEn')}
          </p>
          <div className="gold-line mx-auto mb-5"></div>
          <p className="text-[15px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[700px] mx-auto">
            {t('contact.guides.lead')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {guides.map((guide, idx) => (
            <Link
              key={idx}
              to={guide.href}
              className="card-glow group block bg-background-100/60 border border-background-200/60 p-6 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-4 text-accent-500">
                <i className={`${guide.icon} text-xl`}></i>
              </div>
              <p className="text-[13px] text-accent-500/70 tracking-[0.12em] mb-1 font-label">
                {guide.titleEn}
              </p>
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {guide.title}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-4">
                {guide.description}
              </p>
              <span className="inline-flex items-center gap-2 text-[13px] text-accent-500 group-hover:text-accent-400 transition-colors tracking-[0.06em]">
                {guide.linkLabel}
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
